function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 25.6c-.2 0-.4-.1-.5-.4s0-.4.2-.6c1.7-1 2.4-2.5 2.6-3.2C8.3 20 7.2 18 7.2 16c0-1 .3-2 .8-3 .5-.9 1.2-1.7 2.1-2.4 1.8-1.4 4.2-2.2 6.7-2.2s4.9.8 6.7 2.2c.9.7 1.6 1.5 2.1 2.4.5.9.8 1.9.8 3 0 1-.3 2-.8 3-.5.9-1.2 1.7-2.1 2.4-1.8 1.4-4.2 2.2-6.7 2.2-1 0-2-.1-3-.4-.4.3-1.2.8-2.2 1.3-1.5.8-2.8 1.1-3.8 1.1zm9-16c-4.7 0-8.5 2.9-8.5 6.5 0 1.8 1 3.6 2.8 4.8.2.1.3.3.2.5-.1.4-.5 1.6-1.6 2.8 1.3-.5 2.7-1.2 3.7-2 .1-.1.3-.1.4-.1.9.3 1.9.4 3 .4 4.7 0 8.5-2.9 8.5-6.5s-3.8-6.4-8.5-6.4z",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgChatBubble;